<div class="w-full flex flex-col gap-6">
    @if (practiceList.length > 0) {
        <cdk-accordion class="flex flex-col gap-6">
            @for (practice of practiceList; track practice.id) {
                <cdk-accordion-item #practiceAccordion="cdkAccordionItem" class="mt-8">
                    <div
                        class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
                        <button
                            class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                            (click)="practiceAccordion.toggle()" [attr.aria-expanded]="practiceAccordion.expanded">
                            <span>{{ practice.name }}</span>
                            <i class="fa-solid self-center text-xl"
                               [ngClass]="practiceAccordion.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                        </button>
                        @if (practiceAccordion.expanded) {
                            @for (doctor of practice.doctorList; track doctor.id) {
                                <div class="p-6 border-b border-app-primary-10/5">

                                    <div class="flex flex-col lg:flex-row justify-between w-full">
                                        <div class="appointment-info flex flex-col">
                                            <div class="text-xs">
                                                {{ doctor.title ? doctor.title + ' ' : '' }} {{ doctor.firstName }} {{ doctor.lastName }}
                                            </div>
                                            <div class="text-xs mt-2">
                                                {{ doctor.email }}
                                            </div>
                                        </div>
                                        <div class="appointment-info flex flex-col mb-4">
                                            <button class="btn quaternary-button  mt-4" (click)="openDoctorEdit(doctor.id)">
                                                <span>Arzt bearbeiten</span>
                                            </button>
                                            <button class="btn primary-button mt-4"
                                                    (click)="openDoctorSettings(doctor.id)">
                                                <span>Arzteinstellungen bearbeiten</span>
                                            </button>
                                            <button class="btn tertiary-button mt-4" (click)="openConfirmModal(doctor.id)">
                                                <span>Arzt löschen</span>
                                            </button>
                                        </div>
                                    </div>
                                    @if (doctorEditInPractice === doctor.id) {
                                        <app-doctor-edit [doctor]="doctor"
                                                         (updated)="handleDoctorUpdated($event, practice)"
                                                         (triggerDoctorEdit)="openDoctorEdit(doctor.id)"></app-doctor-edit>
                                    }
                                    @if (doctorSettingsOpen === doctor.id) {
                                        <app-administration-doctor-settings
                                            [doctorId]="doctor.id"></app-administration-doctor-settings>
                                    }
                                </div>
                            }
                            <div class="flex justify-end p-4">
                                <button class="btn primary-button mt-4" (click)="openDoctorCreate(practice.id)">
                                    <span>Arzt hinzufügen</span>
                                </button>
                            </div>
                            <div
                                class="p-4 border-b border-app-primary-10/5"
                                [style.display]="doctorCreateInPractice === practice.id ? '' : 'none'">
                                <app-doctor-create [practiceId]="practice.id"
                                                   (created)="handleDoctorCreated($event, practice)"
                                                   (triggerDoctorCreate)="openDoctorCreate(practice.id)"></app-doctor-create>
                            </div>
                        }
                    </div>
                </cdk-accordion-item>
            }
        </cdk-accordion>
    }
</div>
